import InstagramUnverifiedIcon from "@/assets/colorable/instagram_unverified.svg?react";
import ProhibitedIcon from "@/assets/colorable/prohibited.svg?react";
import ProhibitedClockIcon from "@/assets/colorable/prohibited_clock.svg?react";
import TiktokUnverifiedIcon from "@/assets/colorable/tiktok_unverified.svg?react";
import UgcUnverifiedIcon from "@/assets/colorable/ugc_unverified.svg?react";
import UserTimesIcon from "@/assets/colorable/user_times.svg?react";
import WarningIcon from "@/assets/colorable/warning.svg?react";
import clsxm from "@/lib/clsxm";
import type {TPunishmentType} from "@/store/types";
import {getDisciplineColor} from "@/utils/disciplineUtils";
import {type FC} from "react";

const DisciplineMark: FC<{
  className?: string;
  type: TPunishmentType | "GENERAL_UNVERIFIED";
  variant?: "outline" | "fill";
}> = ({className, type, variant = "fill"}) => {
  const style = {color: variant === "outline" ? `var(--color-${getDisciplineColor(type)})` : "white"};

  const getIcon = () => {
    switch (type) {
      case "PERMANENT_BAN":
        return <ProhibitedIcon style={style} />;
      case "PROBATION":
        return <WarningIcon style={style} />;
      case "TIMED_BAN":
        return <ProhibitedClockIcon style={style} />;
      case "UN_VERIFIED_INSTAGRAM":
        return <InstagramUnverifiedIcon style={style} />;
      case "UN_VERIFIED_TIKTOK":
        return <TiktokUnverifiedIcon style={style} />;
      case "UN_VERIFIED_UGC":
        return <UgcUnverifiedIcon style={style} />;
      default:
        return <UserTimesIcon style={style} />;
    }
  };

  return (
    <div
      className={clsxm("flex size-8 items-center justify-center rounded-md", className)}
      style={{backgroundColor: variant === "outline" ? "" : `var(--color-${getDisciplineColor(type)})`}}>
      {getIcon()}
    </div>
  );
};

export default DisciplineMark;
